import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IComment } from "src/pages/Summary/Summary.types";

export interface IToVerifyItem {
  id: string;
  idType: string;
}
export interface ISummaryFilters {
  entriesType: string;
  entriesStatus: string;
  logbook: string;
  page: number;
}

interface VerifySlice {
  toVerify: IToVerifyItem[];
  comments: IComment[];
  summaryFilters: ISummaryFilters;
}

const initialState: VerifySlice = {
  toVerify: [],
  comments: [],
  summaryFilters: {
    entriesType: "all",
    entriesStatus: "1",
    logbook: "*",
    page: 1,
  },
};

export const verifySlice = createSlice({
  name: "verifySlice",
  initialState,
  reducers: {
    addToVerify: (state, action: PayloadAction<IToVerifyItem>) => {
      state.toVerify.push(action.payload);
    },
    removeFromVerify: (state, action: PayloadAction<IToVerifyItem>) => {
      state.toVerify = state.toVerify.filter(e => e.id !== action.payload.id);
    },
    setToVerify: (state, action: PayloadAction<IToVerifyItem[]>) => {
      state.toVerify = action.payload;
    },
    setComments: (state, action: PayloadAction<IComment[]>) => {
      state.comments = action.payload;
    },
    setSummaryFilter: (
      state,
      action: PayloadAction<{ filter: keyof ISummaryFilters; value: any }>,
    ) => {
      const { filter, value } = action.payload;
      (state.summaryFilters as any)[filter] = value;
    },
    resetSummaryFilters: state => {
      state.summaryFilters = initialState.summaryFilters;
    },
    resetVerifySlice: state => ({
      ...state,
      toVerify: [],
      comments: [],
    }),
  },
});

export const {
  addToVerify,
  setToVerify,
  removeFromVerify,
  setComments,
  resetVerifySlice,
  setSummaryFilter,
  resetSummaryFilters,
} = verifySlice.actions;

export default verifySlice.reducer;
